{
  "loading": "Checking your request…",
  "title": "Pickup request",
  "introduction": "You would like to ask your partner {storeName} to initiate the following after-sales service pickup as soon as possible:",
  "photo": {
    "label": "Take a photo of your BOX Pallet / Cardboard Box so the store can arrange the associated transport",
    "dropzoneTitle": "Drop the photo here",
    "acceptedFormats": "Accepted formats: JPG, PNG, HEIC (10 MB maximum)",
    "takePhoto": "Take a photo",
    "remove": "Remove photo",
    "hint": "A photo is required so the store can arrange the associated transport.",
    "errors": {
      "required": "A photo is required.",
      "type": "The photo must be a JPEG, PNG or HEIC file.",
      "size": "The photo must not exceed 10 MB."
    }
  },
  "availableFromDate": {
    "label": "From which date can the store collect your after-sales service batch?",
    "placeholder": "DD/MM/YYYY"
  },
  "phoneNumber": {
    "label": "Which phone number can the store use when arriving on site?",
    "placeholder": "On-site phone number"
  },
  "comment": {
    "label": "Would you like to add a comment? (optional)",
    "placeholder": "Add any useful pickup information"
  },
  "preparation": "Thank you very much for your trust. Please prepare the pallet / parcel as carefully as possible to simplify transport.",
  "submit": "Send request",
  "retrySubmission": "Retry submission",
  "submissionError": "The request could not be sent. Your information has been retained; please retry.",
  "captchaError": "The security check could not be completed. Your information has been retained; please retry.",
  "loadError": {
    "title": "Unable to verify the link",
    "message": "A connection error is preventing us from checking your request. Please retry.",
    "retry": "Retry"
  },
  "invalid": {
    "title": "Invalid or revoked link",
    "message": "This link is no longer valid. Please contact your after-sales service representative."
  },
  "success": {
    "title": "Request sent",
    "message": "Thank you. Your request has been sent. Please prepare the BOX Pallet / Cardboard Box for pickup."
  }
}
